<template>
  <div class="imgCard" :class="[card_type, img_type]" :style="{ paddingTop: padding_top ? padding_top : '' }">
    <v-lazy-img
      :data-srcset="data_srcset || srcset "
      :src="data_src"
      :data-url="data_url"
      :alt="data_alt"
      :style="{
        backgroundColor: use_product_card_config && img_backgorund,
        objectFit: use_product_card_config && (card_img_style || 'contain'),
      }"
      @load.once="load && load()"
    />
    <slot />
  </div>
</template>
<script>
import { mapState } from 'vuex'
//import LazyImg from '@/js/components/LazyImg.vue'
export default {
  props: {
    card_type: {
      type: [String],
      default: 'square', // square正方形|horizon横形|vertical竖形|auto宽度百分百高度自适应|auto1宽高均自适应 设置卡片图片类型
    },
    img_type: {
      type: [String], // 与card_type不冲突 可同时存在 cover 设置为改模式时 图片外盒子形状任然根据card_type,但图片自身不会被压缩，而是被盒子居中裁剪。
    },
    padding_top: {
      type: [String], // 自定义高度比例 100%，优先级高于card_type
    },
    data_srcset: {
      type: [String], // 图片响应式地址
    },
    data_src: {
      type: [String], // 图片占位图,若需要图片占位则传入模糊的图片，该src不会懒加载！
    },
    data_url: {
      type: [String], // 图片原始地址
    },
    load: {
      type: Function, //图片加载完成函数
    },
    error: {
      type: Function, //图片加载失败函数
    },
    data_alt: {
      type: String,
      default: '',
    },
    data_title: {
      type: String,
      default: '',
    },
    srcset: {
      type: String,
      default: '',
    },
    use_product_card_config: {
      // 是否使用产品卡片的配置
      type: Boolean,
    },
  },
  mounted(){
    console.log(this.data_url,'data_urldata_url');
  },
  watch:{
    data_url:{
      handler(newV){
        console.log(newV,'newVV');
      },
      immediate:true,
    }
  },
  computed: {
    ...mapState({
      img_backgorund: ({ options }) => options?.theme?.global?.colors?.img_backgorund,
      card_img_style: ({ options }) => options?.theme?.global?.product_cart?.card_img_style,
    }),
  },
  components: {
    //LazyImg,
  },
}
</script>
<style scoped lang='scss'>
.imgCard {
  display: inline-block;
  position: relative !important;
  width: 100%;
  box-sizing: border-box;
  &.cover > img,
  &.square > img,
  &.horizon > img,
  &.vertical > img {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.cover {
  overflow: hidden;
  & > img {
    object-fit: cover;
  }
}
.square {
  padding-top: 100%;
}

.horizon {
  padding-top: 75%;
}

.vertical {
  padding-top: 133%;
}

.vertical2 {
  padding-top: 150% !important;
}
.auto {
  padding-top: unset;
  & > img {
    display: block;
    position: relative;
    width: 100%;
  }
}
.auto1 {
  padding-top: unset;
  & > img {
    position: relative;
    top: unset;
    left: unset;
    width: unset;
    height: unset;
    max-width: 100%;
  }
}
</style>
